<a mat-list-item class="menu-item"
    *ngIf="item().subItems && hasPermission(item().name)"
    (click)="toggleNested()">
    <mat-icon matListItemIcon class="text-white"> {{ item().icon}}</mat-icon>

    <span matListItemTitle class="text-white" *ngIf="!collapsed()">{{item().label}}</span>
    <span matListItemMeta class="text-white">
        <mat-icon *ngIf="nestedMenuOpen()">expand_less</mat-icon>
        <mat-icon *ngIf="!nestedMenuOpen()">expand_more</mat-icon>
    </span>
</a>
<a mat-list-item class="menu-item"
    *ngIf="!item().subItems && hasPermission(item().name)"
    [routerLink]="item().routeLink"
    (click)="toggleNested()"
    routerLinkActive="selected-menu-item"
    #rla="routerLinkActive"
    [activated]="rla.isActive">
    <mat-icon [fontSet]="rla.isActive?'material-icons': 'material-icons-outlined'" [class]="rla.isActive?'text-primary':'text-white'" matListItemIcon> {{ item().icon}}</mat-icon>

    <span matListItemTitle [class]="rla.isActive?'text-primary fw-bold':'text-white'" *ngIf="!collapsed()">{{item().label}}</span>
</a>
<div *ngIf="item().subItems && nestedMenuOpen()">
    <ng-container *ngFor="let subItem of item().subItems">
        <a mat-list-item class="menu-item"
            *ngIf="hasPermission(item().name)"
            [class.indented]="!collapsed()"
            [routerLink]="item().routeLink + '/'+ subItem.routeLink"
            routerLinkActive="selected-menu-item"
            #rla="routerLinkActive"
            [activated]="rla.isActive">
            <mat-icon [fontSet]="rla.isActive?'material-icons': 'material-icons-outlined'" [class]="rla.isActive?'text-primary':'text-white'" matListItemIcon> {{ subItem.icon}}</mat-icon>
            <span matListItemTitle [class]="rla.isActive?'text-primary fw-bold':'text-white'" *ngIf="!collapsed()">{{subItem.label}}</span>
        </a>
    </ng-container>
</div>
